import React, { useEffect } from 'react';

import { ForwardRequestForm } from '#/features/request-forwarding';
import { TimesheetApprovalOld } from '#/features/timesheet-approval';
import { TimesheetApproval } from '#/features/timesheet-approval';
import { VerifyRequestForm } from '#/features/timesheet-verification';
import { useAccessToken } from '#/shared/hooks/useAccessToken';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetActionViewStore } from '#/shared/stores/timesheetActionViewStore';

import { TimesheetActionsSelection } from './TimesheetActionsSelection';

type TimesheetActionsContainerProps = {
  bannerElement: React.ReactElement;
  actionsContainerRef: React.RefObject<HTMLDivElement | null>;
};

export function TimesheetActionsContainer({
  bannerElement,
  actionsContainerRef,
}: Readonly<TimesheetActionsContainerProps>) {
  const token = useAccessToken();
  const pageState = usePageStateStore(state => state.pageState);
  const currentView = useTimesheetActionViewStore(state => state.currentView);
  const setView = useTimesheetActionViewStore(state => state.setView);
  const { isEnabled: timesheetActionsSelectionIsEnabled } = useFeatureFlag('PPL-2239-timesheet-actions-selection');

  // forward=true URL parameter handling sets the view to forward by default
  useEffect(() => {
    // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this feature flag check
    if (!timesheetActionsSelectionIsEnabled) {
      return;
    }
    if (!token || pageState !== 'loading-success') {
      return;
    }
    if (window.location.search.includes('forward=true')) {
      setView('forward');
    }
  }, [token, pageState, timesheetActionsSelectionIsEnabled, setView]);

  // TODO: PPL-2239-timesheet-actions-selection cleanup - remove this if statement
  if (timesheetActionsSelectionIsEnabled) {
    return (
      <div ref={actionsContainerRef}>
        {currentView === 'actions' && (
          <>
            <TimesheetActionsSelection />
          </>
        )}

        {currentView === 'approve' && <TimesheetApproval />}

        {currentView === 'verify' && <VerifyRequestForm />}

        {currentView === 'forward' && <ForwardRequestForm />}
      </div>
    );
  }

  // TODO: PPL-2239-timesheet-actions-selection cleanup - remove this return statement
  return <TimesheetApprovalOld bannerElement={bannerElement} />;
}
